import { Component, ElementRef, OnInit, ViewChild, Input, Output, EventEmitter, HostListener, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Estimate } from 'src/app/models/Estimate';
import { ApiEstimativaService } from 'src/app/modules/shared/services/api-estimativa.service';
import { DataService } from 'src/app/modules/shared/services/data.service';

import { Router } from '@angular/router';
import { LanguageService } from 'src/app/modules/shared/services/language.service';
import { ProjectsService } from 'src/app/modules/shared/services/projects.service';
import { MatDialog } from '@angular/material/dialog';
import { AcceptCommentEstimateDialog } from '../accept-comment-estimate-dialog/accept-comment-estimate-dialog.component';
import { ConfirmInitialCostDialogComponent } from '../confirm-initial-cost-dialog/confirm-initial-cost-dialog.component';
import { retryWhen, catchError, scan, delay, filter, switchMap, take } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/shared/services/auth.service';
import { InfoBarWithStatusService } from 'src/app/modules/shared/services/info-bar-with-status.service';
import { getEstimationErrorMessages } from 'src/app/constants/estimation-error-messages';
import { ProfileService } from 'src/app/modules/shared/services/profile.service';
import { Profile } from 'src/app/models/Profile';
import { Permission } from 'src/app/modules/shared/security/permission';
import { PermissionService } from 'src/app/modules/shared/services/permission.service';
import { EstimationState } from 'src/app/models/EstimationState';
import { NotificationsService } from 'src/app/modules/shared/services/notifications.service';
import { Roles } from 'src/app/models/Roles';
import { throwError, timer } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.css'],
})
export class ResultComponent implements OnInit {

  @Input() estId?: string;
  @Input() sideNavStatus!: boolean;
  @Output() estimateNameChange = new EventEmitter<string>();
  @Output() estimateState = new EventEmitter<EstimationState>();

  Permission = Permission
  Roles = Roles
  variables: any;
  math = Math;
  message = '';

  projectName: string = '';

  div1Visible: boolean = false;
  div2Visible: boolean = false;
  div3Visible: boolean = false;
  div4Visible: boolean = false;
  div5Visible: boolean = false;
  div6Visible: boolean = false;
  div8Visible: boolean = false
  divTasksVisible: boolean = false;
  divComponenetsVisible: boolean = false;
  divSocVisible: boolean = false;
  totalProjectRisk: any;
  
  totalCostRisk: number = 0;
  totalCostConfig: number = 0;
  totalCostParams: number = 0;
  totalCostMacros: number = 0;
  totalCostActivities: number = 0;
  totalCostProdTools: number = 0;
  totalCostTotal: number = 0;
  totalCostTotalRisk: number = 0;
  finalCostEuros: number = 0;
  hasCosts: boolean = false;
  project: any;
  architect: boolean = false;
  canShowEstimative: boolean = true;

  totalScrActivities: any = 0;
  totalScrConfig: any = 0;
  totalScrParams: any = 0;
  totalScrMacros: any = 0;
  totalScrRisk: any = 0;
  totalScrProdTools: any = 0;
  totalScrTotal: any = 0;

  formGroup: any;
  formGroupCeco: any;
  formEditRiskMargin: any;

  isOwner: boolean = false;
  creator: String = '';
  email: String = '';
  role: String = '';

  projectId: string = '';

  medios: any[] = [];
  closestItem: any;
  medium: any = 0;
  gestao: any = 0;
  conf: any = 0;
  desenv: any = 0;
  totalEst: any = 0;

  editMode: boolean = false;
  totalSumStr!: string;
  totalProjectRiskStr: any;
  totalConfigurationsStr!: string;
  totalParametersStr!: string;
  totalMacroStr!: string;
  totalCatalogStr!: string;
  totalToolsStr!: string;

  isAgileAndCertified: boolean = false;
  startingEstimate: any;
  availableProfiles: Profile[] = [];
  profileSearchTerm: string = '';

  isLoadingEstimate: boolean = true;
  isLoadingCalculate: boolean = true;

  errorDetected: boolean = false;
  errorText: string = '';
  canShowAddCommentButton: boolean = false;

  originalProfileSnapShots: any[] = []

  @ViewChild('result') element!: ElementRef;
  expandRecommendedWidth = 0;

  toggleDivVisibility(id: number): void {
    switch (id) {
      case 1:
        this.div1Visible = !this.div1Visible;
        break;
      case 2:
        this.div2Visible = !this.div2Visible;
        break;
      case 3:
        this.div3Visible = !this.div3Visible;
        break;
      case 4:
        this.div4Visible = !this.div4Visible;
        break;
      case 5:
        this.div5Visible = !this.div5Visible;
        break;
      case 6:
        this.div6Visible = !this.div6Visible;
        break;
      //case 7:
      //  this.divTasksVisible = !this.divTasksVisible
      // break;
      case 8:
        this.div8Visible = !this.div8Visible;
        break;
      case 9:
        this.divSocVisible = !this.divSocVisible;
        break;
      default:
        break;
    }
  }

  checkButton(elemName: string) {
    if (!(elemName == this.variables.total || elemName == this.variables.totalNoRisk)) {
      return true;
    }
    else { return false; }
  }

  private getExpandableRowIdsInData(): number[] {
    const expandableIds = [2, 3, 4, 5, 6, 8];
    const currentRows = this.totalDataSource?.data as any[] || [];
    return expandableIds.filter((id) => currentRows.some((row) => row?.id === id));
  }

  hasExpandableRows(): boolean {
    return this.getExpandableRowIdsInData().length > 0;
  }

  areAllDetailTablesExpanded(): boolean {
    const expandableIds = this.getExpandableRowIdsInData();
    if (expandableIds.length === 0) {
      return false;
    }

    return expandableIds.every((id) => this.isParentRowExpanded({ id }));
  }

  toggleAllDetailTables(): void {
    const shouldExpandAll = !this.areAllDetailTablesExpanded();
    const expandableIds = this.getExpandableRowIdsInData();

    this.div2Visible = shouldExpandAll && expandableIds.includes(2);
    this.div3Visible = shouldExpandAll && expandableIds.includes(3);
    this.div4Visible = shouldExpandAll && expandableIds.includes(4);
    this.div5Visible = shouldExpandAll && expandableIds.includes(5);
    this.div6Visible = shouldExpandAll && expandableIds.includes(6);
    this.div8Visible = shouldExpandAll && expandableIds.includes(8);
  }

  isParentRowExpanded(row: any): boolean {
    if (row?.id === 8) {
      return this.div8Visible;
    }
    if (row?.id === 2) {
      return this.div2Visible;
    }
    if (row?.id === 3) {
      return this.div3Visible;
    }
    if (row?.id === 4) {
      return this.div4Visible;
    }
    if (row?.id === 5) {
      return this.div5Visible;
    }
    if (row?.id === 6) {
      return this.div6Visible;
    }
    return false;
  }

  isExpandedDetailRow = (_index: number, row: any): boolean => {
    return this.checkButton(row?.name) && this.isParentRowExpanded(row);
  };

  getExpandedColumns(row: any): string[] {
    switch (row?.id) {
      case 2:
        return this.hasCosts ? this.configurationDisplayedColumns : this.configurationDisplayedColumnsNoCosts;
      case 3:
        return this.hasCosts ? this.parametersDisplayedColumns : this.parametersDisplayedColumnsNoCosts;
      case 4:
        return this.hasCosts ? this.macroDisplayedColumns : this.macroDisplayedColumnsNoCosts;
      case 5:
        if (this.estimate?.projectMetodology === 'agile' && this.estimate?.estimateMode === 'complex') {
          return this.hasCosts ? this.filteredCatalogDisplayedColumns : this.filteredCatalogDisplayedColumnsNoCosts;
        }
        if (this.estimate?.projectMetodology === 'agile' && this.estimate?.estimateMode === 'tshirt') {
          return this.hasCosts ? this.filteredCatalogDisplayedColumns : this.filteredCatalogDisplayedColumnsNoCosts;
        }
        return this.hasCosts ? this.catalogDisplayedColumns : this.catalogDisplayedColumnsNoCosts;
      case 6:
        return this.hasCosts ? this.toolsdisplayColumns : this.toolsdisplayColumnsNoCost;
      case 8:
        return this.hasCosts ? this.riskDisplayedColumns : this.riskDisplayedColumnsNoCosts;
      default:
        return [];
    }
  }

  getExpandedRows(row: any): any[] {
    switch (row?.id) {
      case 2:
        return this.configurationDataSource.data;
      case 3:
        return this.parametersDataSource.data;
      case 4:
        return this.macroDataSource.data;
      case 5:
        if (!this.estimate.complexityLevel && !this.estimate.tshirtScaleLevel)
          return this.tasksDataSource.data;

        if (this.estimate?.projectMetodology === 'agile' && this.estimate?.estimateMode === 'complex')
          return this.filteredCatalogDataSourceMode1;
        else if (this.estimate?.projectMetodology === 'agile' && this.estimate?.estimateMode === 'tshirt')
          return this.filteredCatalogDataSourceMode2;

        return this.tasksDataSource.data;

      case 6:
        return this.toolsDataSource.data;
      case 8:
        return this.projectRiskDataSource.data;
      default:
        return [];
    }
  }

  getExpandedHeader(row: any, column: string): string {
    if (column === 'dummy') {
      return '';
    }

    switch (row?.id) {
      case 2:
      case 3:
        return this.getConfigParamHeader(column);
      case 4:
        return this.getMacroHeader(column);
      case 5:
        return this.getTaskHeader(column);
      case 6:
        return this.getToolHeader(column);
      case 8:
        return this.getRiskHeader(column);
      default:
        return '';
    }
  }

  getExpandedCellValue(row: any, column: string, detail: any): string {
    if (column === 'dummy') {
      return '';
    }

    switch (row?.id) {
      case 2:
      case 3:
        return this.getConfigParamCellValue(column, detail);
      case 4:
        return this.getMacroCellValue(column, detail);
      case 5:
        return this.getTaskCellValue(column, detail);
      case 6:
        return this.getToolCellValue(column, detail);
      case 8:
        return this.getRiskCellValue(column, detail);
      default:
        return '';
    }
  }

  shouldShowProfileSelector(column: string, detail: any): boolean {
    return column === 'profile' && this.hasCosts && this.editMode && !!detail?.sourceGroup;
  }

  private getConfigParamHeader(column: string): string {
    switch (column) {
      case 'name':
        return this.variables.description;
      case 'complexity':
        return `${this.variables.effort} (${this.variables.hours})`;
      case 'profile':
        return `${this.variables.profile} ${this.variables.eurosPerHour}`;
      case 'cost':
        return this.variables.cost;
      default:
        return '';
    }
  }

  private getMacroHeader(column: string): string {
    switch (column) {
      case 'name':
        return this.variables.description;
      case 'metodology':
        return this.variables.metodology;
      case 'complexity':
        return `${this.variables.effort} (%)`;
      case 'effort':
        return `${this.variables.effort} (${this.variables.hours})`;
      case 'profile':
        return `${this.variables.profile} ${this.variables.eurosPerHour}`;
      case 'cost':
        return this.variables.cost;
      default:
        return '';
    }
  }

  private getTaskHeader(column: string): string {
    if (this.estimate?.projectMetodology === 'agile' && this.estimate?.estimateMode === 'tshirt' && column === 'complexity') {
      return this.variables.tshirtSize;
    }

    switch (column) {
      case 'epic':
        return this.variables.epic;
      case 'task':
        return this.variables.task;
      case 'userStory':
        return this.variables.userStory;
      case 'subTask':
        return this.variables.subTask;
      case 'complexity':
        return this.variables.complexity;
      case 'complexityCount':
        return `${this.variables.numberOfItems} x ${this.variables.effort}(h)`;
      case 'profile':
        return `${this.variables.profile} ${this.variables.eurosPerHour}`;
      case 'cost':
        return this.variables.cost;
      default:
        return '';
    }
  }

  private getToolHeader(column: string): string {
    switch (column) {
      case 'task':
        return this.variables.task;
      case 'subTask':
        return this.variables.subTask;
      case 'toolName':
        return this.variables.tool;
      case 'productivity':
        return this.variables.earnPercentual1;
      case 'gains':
        return this.variables.gainHour;
      case 'profile':
        return `${this.variables.profile} ${this.variables.eurosPerHour}`;
      case 'cost':
        return this.variables.cost;
      default:
        return '';
    }
  }

  private getRiskHeader(column: string): string {
    switch (column) {
      case 'name':
        return this.variables.projectType;
      case 'risk':
        return `${this.variables.risk} (%)`;
      case 'effort':
        return `${this.variables.effort} (h)`;
      case 'profile':
        return `${this.variables.profile} ${this.variables.eurosPerHour}`;
      case 'cost':
        return this.variables.cost;
      default:
        return '';
    }
  }

  private getConfigParamCellValue(column: string, detail: any): string {
    switch (column) {
      case 'name':
        return detail.name;
      case 'complexity':
        return this.toFixedValue(detail.complexity);
      case 'profile':
        return `${detail.profileName} ${this.toFixedValue(detail.profile)}`;
      case 'cost':
        return this.toFixedValue(detail.cost);
      default:
        return '';
    }
  }

  private getMacroCellValue(column: string, detail: any): string {
    switch (column) {
      case 'name':
        return detail.name;
      case 'metodology':
        return detail.type;
      case 'complexity':
        return this.toFixedValue(detail.effort);
      case 'effort':
        return this.toFixedValue(detail.complexity);
      case 'profile':
        return `${detail.profileName} ${this.toFixedValue(detail.profile)}`;
      case 'cost':
        return this.toFixedValue(detail.cost);
      default:
        return '';
    }
  }

  private getTaskCellValue(column: string, detail: any): string {
    switch (column) {
      case 'epic':
        return detail.epic || detail.name || '';
      case 'userStory':
        return detail.userStory || '';
      case 'task':
        return detail.task || '';
      case 'subTask':
        return detail.subTask || '';
      case 'complexity':
        if (this.estimate?.projectMetodology === 'agile' && this.estimate?.estimateMode === 'tshirt') {
          return detail.tshirtScaleLevel || '';
        }
        return detail.complexityLevel === '1' ? this.variables.low1
          : detail.complexityLevel === '2' ? this.variables.medium1
          : detail.complexityLevel === '3' ? this.variables.high1
          : this.variables.notApplic;
      case 'complexityCount':
        return detail.complexityCount || '';
      case 'profile':
        return `${detail.profileName} ${this.toFixedValue(detail.profile)}`;
      case 'cost':
        return this.toFixedValue(detail.cost);
      default:
        return '';
    }
  }

  private getToolCellValue(column: string, detail: any): string {
    switch (column) {
      case 'task':
        return detail.actionName;
      case 'subTask':
        return detail.activityName;
      case 'toolName':
        return detail.toolName;
      case 'productivity':
        return this.toFixedValue(detail.productivity);
      case 'gains':
        return this.toFixedValue(detail.gains);
      case 'profile':
        return `${detail.profileName} ${this.toFixedValue(detail.profile)}`;
      case 'cost':
        return this.toFixedValue(detail.cost);
      default:
        return '';
    }
  }

  private getRiskCellValue(column: string, detail: any): string {
    switch (column) {
      case 'name':
        return detail.name;
      case 'risk':
        return this.toFixedValue(detail.risk);
      case 'effort':
        return this.toFixedValue(detail.effort);
      case 'profile':
        return `${detail.profileName} ${this.toFixedValue(detail.profile)}`;
      case 'cost':
        return this.toFixedValue(detail.cost);
      default:
        return '';
    }
  }

  private toFixedValue(value: any): string {
    return typeof value === 'number' ? value.toFixed(2) : value ?? '';
  }

  currentDate: string = '';
  estimate: any;
  summaryDTO: any;

  projectRiskDataSource: any = new MatTableDataSource();
  riskDisplayedColumns: string[] = ['name', 'dummy', 'riskEffort', 'complexity', 'risk', 'effort', 'profile', 'cost'];
  riskDisplayedColumnsNoCosts: string[] = ['name', 'dummy', 'dummy', 'dummy', 'riskEffort', 'complexity', 'risk', 'effort' ];

  configurationDataSource: any = new MatTableDataSource();
  configurationDisplayedColumns: string[] = ['name', 'dummy', 'dummy', 'dummy', 'dummy', 'complexity', 'profile', 'cost'];
  configurationDisplayedColumnsNoCosts: string[] = ['name', 'dummy', 'dummy', 'dummy', 'dummy', 'dummy', 'dummy','complexity'];

  parametersDataSource: any = new MatTableDataSource();
  parametersDisplayedColumns: string[] = ['name', 'dummy', 'dummy', 'dummy', 'dummy', 'complexity', 'profile', 'cost'];
  parametersDisplayedColumnsNoCosts: string[] = ['name', 'dummy', 'dummy', 'dummy', 'dummy', 'dummy', 'dummy', 'complexity'];

  macroDataSource: any = new MatTableDataSource();
  macroDisplayedColumns: string[] = ['name', 'metodology', 'dummy', 'dummy', 'complexity', 'effort', 'profile', 'cost'];
  macroDisplayedColumnsNoCosts: string[] = ['name', 'metodology', 'dummy', 'dummy', 'dummy', 'dummy', 'complexity', 'effort'];

  tasksDataSource: any = new MatTableDataSource();
  catalogDisplayedColumns: string[] = ['task', 'dummy', 'dummy', 'subTask', 'complexity', 'complexityCount', 'profile', 'cost'];
  catalogDisplayedColumnsNoCosts: string[] = ['task', 'dummy', 'dummy', 'subTask','dummy', 'dummy','complexity', 'complexityCount'];
  
  toolsDataSource:  any = new MatTableDataSource();
  toolsdisplayColumns: string[] = ['toolName', 'dummy', 'task', 'subTask', 'productivity', 'gains', 'profile', 'cost'];
  toolsdisplayColumnsNoCost: string[] = ['toolName', 'dummy', 'task', 'subTask', 'dummy', 'dummy','productivity', 'gains'];


  filteredCatalogDataSourceMode1: any[] = [];
  filteredCatalogDataSourceMode2: any[] = [];
  filteredCatalogDisplayedColumns: string[] = ['epic', 'userStory', 'task', 'subTask', 'complexity', 'complexityCount', 'profile', 'cost'];
  filteredCatalogDisplayedColumnsNoCosts: string[] = ['epic', 'userStory', 'task', 'subTask', 'dummy', 'dummy','complexity', 'complexityCount'];
  
  totalDataSource = new MatTableDataSource();
  totalDataSourceServices: any = [];
  totalDisplayedColumns: string[] = ['name', 'dummy', 'dummy', 'dummy', 'dummy', 'dummy', 'dummy', 'effort'];
  totalDisplayedColumnsWithCost: string[] = ['name', 'dummy', 'dummy', 'dummy', 'dummy', 'effort', 'profile', 'cost'];
  expandedDetailColumns: string[] = ['expandedDetail'];

  criticality = 0;
  totalProjectTypeComp = 0;
  totalDocumentations = 0;
  totalConfigurations = 0;
  totalParameters = 0;
  totalMacro = 0;
  totalSubTasks = 0;
  totalSum = 0;
  totalSumNoRisk = 0;
  totalCostTotalNoRisk = 0;
  totalSumRisk = 0;
  totalSumNoTools = 0;
  averageProfile = 0;
  averageProfileMacro = 0;
  averageProfileSubTasks = 0;
  averageProfileTools = 0;
  averageProfileConfig = 0;
  averageProfileParams = 0;
  averageProfileNoRisk = 0;
  averageProfileRisk = 0;
  totalToolHourFraction = 0;

  totalRisk = 0;
  totalTools = 0;
  button: boolean = false;
  isCertified: boolean = false;
  isAdmin: boolean = false;
  sliderValue: number = 0;
  previousSliderValue: number = 0;
  maxSliderValue = 0;
  showSliderDisclaimer: boolean = false;


  errorMessages: any;

  sliderValues: { value: number, type: string }[] = [];

  constructor(
    private dataService: DataService,
    private estimativaService: ApiEstimativaService,
    private router: Router,
    private languageService: LanguageService,
    private projectService: ProjectsService,
    private infoBar: InfoBarWithStatusService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    public authService: AuthService,
    private profileService: ProfileService,
    public permissionService: PermissionService,
    public notificationsService: NotificationsService
  ) {
  }

  private estimateForm: any;
  private atividades: any;

  public estimationState = EstimationState;

  ngOnInit(): void {

    // When opened via a deep link the container passes the raw id string.
    // Seed DataService so getEstimateById can resolve it.
    if (this.estId) {
      this.dataService.setEstimate(this.estId);
    }

    const currentEstimate = this.dataService.getEstimate();
    const hasEstimate = currentEstimate !== null && currentEstimate !== undefined
      && (typeof currentEstimate === 'string'
        ? currentEstimate.trim().length > 0
        : Object.keys(currentEstimate).length > 0);

    if (!hasEstimate) {
      console.error('No estimate found, redirecting to dashboard');
      this.router.navigate(['/dashboard']);
      return;
    }

    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.authService.userDataLoaded$.pipe(
      filter(loaded => loaded),
      take(1),
      switchMap(() => this.authService.getUserData().pipe(take(1)))
    ).subscribe(data => {
      this.creator = data.id
      this.email = data.email
      this.role = data.role
      this.updateAddCommentVisibility();
    });


    this.getEstimateById();

    this.errorMessages = getEstimationErrorMessages(this.variables);

    //Get the estimate through the dataService.ts service
    this.estimate = this.dataService.getEstimate();
    this.projectName = this.estimate.project

    this.isAgileAndCertified = (this.estimate.estimateMode !== 'other' && this.estimate.state === this.estimationState.CERTIFIED) ? true : false;
  }

  getEstimateById() {
    this.isLoadingEstimate = true;

    const estimateId = this.estId
      || (typeof this.dataService.getEstimate() === 'object'
        ? this.dataService.getEstimateId()
        : this.dataService.getEstimate());

    if (!estimateId) {
      this.router.navigate(['/dashboard']);
      return;
    }

    this.estimativaService.getEstimateById(estimateId).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error;
            }
            return retryCount + 1;
          }, 0),
          delay(2500)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        //const message = this.errorMessageAllTechs[err.error.message]
        //this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any) => {
        try {
          this.estimate = data;
          this.startingEstimate = JSON.parse(JSON.stringify(data));

          // Emit estimate name to parent component
          if (data.name) {
            this.estimateNameChange.emit(data.name);
          }

          // Emit estimate state to parent component
          if (data.state) {
            this.estimateState.emit(data.state);
          }
          if (data.project) {
            this.projectId = data.project;
            this.getProjectById(this.projectId);
          }
          this.isOwner = data.createdBy == this.creator;
          if (!this.isOwner) {
            this.message = this.variables.messageEditEstimateErrorOwner
          }
          this.updateAddCommentVisibility();

          // If no profileSnapshots (draft/incomplete), load live profiles from API
          //const hasSnapshots = Array.isArray(data.profileSnapshots) && data.profileSnapshots.length > 0;

          //if (!hasSnapshots) {
          if (true) {
            this.profileService.getAllProfiles().subscribe({
              next: (profiles: any[]) => {
                this.availableProfiles = profiles || [];
                //order the available profiles from lowest costPerHour to highest costPerHour
                this.availableProfiles = (profiles || []).sort((a, b) => a.costPerHour - b.costPerHour);

                this.rebuildProfileSnapshotsFromEstimate();

                this.originalProfileSnapShots = JSON.parse(JSON.stringify(this.estimate.profileSnapshots));

                this.calculateEstimate(data.id);
              },
              error: () => {
                // If profiles can't be loaded, calculate without costs
                this.calculateEstimate(data.id);
              }
            });
          } else {
            this.calculateEstimate(data.id);
          }
          //this.setForm(data);
          //this.createMacrosCtrl();

          //this.technologies = data;
        } catch (err) {
          console.error('Error:', err);

          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.estimate && !this.errorDetected) {
          this.isLoadingEstimate = false;
        }
      }
    });
  }

  calculateEstimate(estimateId: string) {
    this.isLoadingCalculate = true;

    console.log(estimateId);

    this.estimativaService.calculate(estimateId).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error;
            }
            return retryCount + 1;
          }, 0),
          delay(2500)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        //const message = this.errorMessageAllTechs[err.error.message]
        //this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any) => {
        try {
          this.summaryDTO = data;

          console.log(this.summaryDTO);


          this.checkHasCosts();
          this.resetResultTables();
          this.setAllTotal(data);
          this.setTable(data, "all");

          if (this.isOwner && this.estimate.state == this.estimationState.COMPLETE) {
            this.updateEstimateTimes();
          }

          //this.setForm(data);
          //this.createMacrosCtrl();

          //this.technologies = data;
        } catch (err) {
          console.error('Error:', err);

          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.summaryDTO && !this.errorDetected) {
          this.isLoadingCalculate = false;
        }
      }
    });
  }

  checkHasCosts(): void {
    /*this.hasCosts = Array.isArray(this.estimate?.profileSnapshots) &&
      this.estimate.profileSnapshots.some((ps: any) => ps.costPerHour && ps.costPerHour > 0);
      */
     this.hasCosts = this.summaryDTO.result.hasCosts;
  }

  getCostPerHourForProfile(profileId: string | null): number {
    if (!profileId || !this.hasCosts || !Array.isArray(this.availableProfiles)) return 0;
    const snapshot = this.availableProfiles.find((ps: any) => ps.id === profileId);
    return snapshot?.costPerHour || 0;
  }

  getProfileName(profileId: string | null): string {
    if (!profileId || !Array.isArray(this.availableProfiles)) return '-';
    const snapshot = this.availableProfiles.find((ps: any) => ps.id === profileId);
    return snapshot?.name || '-';
  }

  getProfileInfoTooltip(profileId: string | null): string {
    if (!profileId) {
      return this.variables?.noProfile || this.variables?.notApplic || '-';
    }

    const profile = this.availableProfiles.find((p: Profile) => p.id === profileId);
    if (profile) {
      return `${profile.center}`;
    }

    const snapshot = this.estimate?.profileSnapshots?.find((ps: any) => ps.profileId === profileId);
    if (snapshot) {
      return `${snapshot.profileCenter}`;
    }

    return '-';
  }

  getProfileIdForItem(groupName: string, index: number): string | null {
    const group = this.estimate?.[groupName];
    if (!Array.isArray(group) || index >= group.length) return null;
    return group[index]?.profileId || null;
  }

  setAllTotal(summaryDTO: any) {

    this.totalConfigurations = summaryDTO.configurations.totalEffort;
    this.totalCostConfig = summaryDTO.configurations.totalCost;
    this.averageProfileConfig =  this.totalCostConfig / this.totalConfigurations;

    this.totalParameters = summaryDTO.parameters.totalEffort;
    this.totalCostParams = summaryDTO.parameters.totalCost;
    this.averageProfileParams =  this.totalCostParams / this.totalParameters;

    this.totalMacro = summaryDTO.macroActivities.totalEffort;
    this.totalCostMacros = summaryDTO.macroActivities.totalCost;
    this.averageProfileMacro =  this.totalCostMacros / this.totalMacro;

    this.totalSubTasks = summaryDTO.projectActivities.totalEffort;
    this.totalCostActivities = summaryDTO.projectActivities.totalCost;
    this.averageProfileSubTasks =  this.totalCostActivities / this.totalSubTasks;

    this.totalTools = summaryDTO.productivityEarnings.totalEffort;
    this.totalCostProdTools = summaryDTO.productivityEarnings.totalCost;
    this.averageProfileTools =  this.totalCostProdTools / this.totalTools;

    this.totalProjectRisk = summaryDTO.risk.totalEffort;
    this.totalCostRisk = summaryDTO.risk.totalCost;
    this.averageProfileRisk =  this.totalCostRisk / this.totalProjectRisk;

    //final total without risk 
    this.totalSumNoRisk = this.totalConfigurations + this.totalParameters + this.totalMacro + this.totalSubTasks - this.totalTools;
    this.totalCostTotalNoRisk = this.totalCostConfig + this.totalCostParams + this.totalCostMacros + this.totalCostActivities - this.totalCostProdTools;
    //check with summarDTO values to set the totalSumNoRisk and totalCostTotalNoRisk
    console.log("summaryDTO.result.totalNoRisk:"+summaryDTO.result.totalNoRisk);
    console.log("summaryDTO.result.totalCostNoRisk:"+summaryDTO.result.totalCostNoRisk);
    console.log("Local sums: "+this.totalSumNoRisk);
    console.log("Local costs: "+this.totalCostTotalNoRisk);
    
    //using summary data
    this.totalSumNoRisk = summaryDTO.result.totalNoRisk;
    this.totalCostTotalNoRisk = summaryDTO.result.totalCostNoRisk

    //final total with risk
    this.totalSum = this.totalProjectRisk + this.totalConfigurations + this.totalParameters + this.totalMacro + this.totalSubTasks - this.totalTools;
    this.totalCostTotal = this.totalCostRisk + this.totalCostConfig + this.totalCostParams + this.totalCostMacros + this.totalCostActivities - this.totalCostProdTools;
  
    //check with summarDTO values to set the totalSum and totalCostTotal
    console.log("summaryDTO.result.finalTotal:"+summaryDTO.result.finalTotal);
    console.log("summaryDTO.result.finalTotalCost:"+summaryDTO.result.finalTotalCost);
    console.log("Local sums: "+this.totalSum);
    console.log("Local costs: "+this.totalCostTotal);

    //using summary data
    this.totalSum = summaryDTO.result.finalTotal;
    this.totalCostTotal = summaryDTO.result.finalTotalCost; 
  
  }

  exportExcel() {
    this.estimativaService.exportExcel(this.estimate.id).subscribe(data => {
      if (data) {
        this.downloadExcel(data, this.estimate.name + ' result.xlsx')
      }
    })
  }

  exportExcelToJira() {

    this.estimativaService.exportToJira(this.buildEstimateForJira()).subscribe(data => {
      console.log(data);
      this.estimativaService.exportDataFromJira().subscribe(data => {
        console.log(data);
      })
    })
  }

  //later modify to send the estimate's Jira project key dynamically
  buildEstimateForJira(): any {
    let subtasks: any[] = [];

    this.estimate.subTasks.map((subtask: any) => {
      subtasks.push({
        "epic": subtask.epic,
        "userStory": subtask.userStory,
        "task": subtask.task,
        "subTask": subtask.subTask,
        "complexityLevel": subtask.complexityLevel,
        "complexity": subtask.complexity + "h",
        "itemCount": subtask.itemCount
      });
    })

    const jiraEstimate = {
      // "projectKey": this.projectName,
      "projectKey": 'TESPT',
      "subTasks": subtasks
    }

    return jiraEstimate;
  }

  private refreshUnreadNotifications(withDelayedRetry: boolean = false) {
    this.authService.getUserData().pipe(
      take(1),
      switchMap((user: any) => {
        const userId = user?.id || this.creator?.toString() || '';

        if (!withDelayedRetry) {
          return this.notificationsService.refreshUnreadCountNow(userId);
        }

        return this.notificationsService.refreshUnreadCountNow(userId).pipe(
          switchMap(() => timer(1200).pipe(
            switchMap(() => this.notificationsService.refreshUnreadCountNow(userId))
          ))
        );
      })
    ).subscribe();
  }

  approveEstimate() {
    const data = {
      title: this.variables.sureToApproveEstimate,
      accept: true,
      isRequired: false,
      commentaryLabel: this.variables.additionalComment
    }

    let dialogRef = this.dialog.open(AcceptCommentEstimateDialog, {
      data: data
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.estimativaService.approveEstimate(this.estimate.id, result.commentary).subscribe({
          next: (data) => {
            if (data.success) {
              this.infoBar.showSnackbar(this.variables.successfullyApprovedEstimate, ['successful-snackbar'], 3500);

              this.refreshUnreadNotifications(true);
              this.getEstimateById();
            }
          },
          error: (error) => {
            console.error('Error:', error.error);

            const message = this.errorMessages[error.error.message]
            this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
          }
        })
      }
      else {
        console.error("Error adding review estimate: ", result.error.message);

        const message = this.errorMessages[result.error.message]
        this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);

        console.error("Error adding review estimate: ", result.message);
      }
    })
  }


  rejectEstimate() {
    const data = {
      title: this.variables.sureToRejectEstimate,
      accept: true,
      isRequired: false,
      commentaryLabel: this.variables.additionalComment
    }

    let dialogRef = this.dialog.open(AcceptCommentEstimateDialog, {
      data: data
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.estimativaService.rejectEstimate(this.estimate.id, result.commentary).subscribe({
          next: (data) => {
            if (data.success) {
              this.infoBar.showSnackbar(this.variables.successfullyRejectedEstimate, ['successful-snackbar'], 3500);

              this.refreshUnreadNotifications(true);
              this.getEstimateById();
            }
          },
          error: (error) => {
            console.error('Error:', error.error);

            const message = this.errorMessages[error.error.message]
            this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
          }
        })
      }
      else {
        console.error("Error adding review estimate: ", result.error.message);

        const message = this.errorMessages[result.error.message]
        this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);

        console.error("Error adding review estimate: ", result.message);
      }
    })
  }


  toFixEstimate() {
    const data = {
      title: this.variables.sureToFixEstimate,
      accept: true,
      isRequired: false,
      commentaryLabel: this.variables.additionalComment
    }

    let dialogRef = this.dialog.open(AcceptCommentEstimateDialog, {
      data: data
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.estimativaService.toFixEstimate(this.estimate.id, result.commentary).subscribe({
          next: (data) => {
            if (data.success) {
              this.infoBar.showSnackbar(this.variables.successfullyToFixEstimate, ['successful-snackbar'], 3500);

              this.refreshUnreadNotifications(true);
              this.getEstimateById();
            }
          },
          error: (error) => {
            console.error('Error:', error.error);

            const message = this.errorMessages[error.error.message]
            this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
          }
        })
      }
      else {
        console.error("Error adding review estimate: ", result.error.message);

        const message = this.errorMessages[result.error.message]
        this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);

        console.error("Error adding review estimate: ", result.message);
      }
    })
  }


  // {
  //     "projectKey": "TESPT",
  //     "subTasks": [
  //     {
  //         "epic": "EPIC 1",
  //         "userStory": "US1",
  //         "task": "Desenvolvimento de APIs Rest",
  //         "subTask": "Sub-Task A",
  //         "complexityLevel": "1",
  //         "complexity": "20h",
  //         "itemCount": 2
  //     },
  //     ]
  // }

  downloadExcel(response: any, fileName: any) {
    // Doing it this way allows you to name the file
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(response);
    link.download = fileName;
    link.click();
  }


  updateEstimate() {

    if (this.isOwner) {
      this.dataService.setEstimate(this.estimate.id);
      this.dataService.setEstimativaNavigationContext({ origin: "resultPage" }); //Set the setEstimativaNavigationContext.
      //sessionStorage.setItem("update", "true"); //Set the update to true, so the service know which endpoint to call.
      this.router.navigate(['/estimativa', { state: { estimateState: this.estimate.state } }])
    }

  }

  goToReviews(className: string) {
    const elementList = document.querySelectorAll('.' + className);
    const element = elementList[0] as HTMLElement;
    element.scrollIntoView({ behavior: 'smooth' });
  }

  acceptEstimate() {

    const data = {
      title: this.variables.sureToAcceptEstimate,
      accept: true,
      isRequired: false,
      commentaryLabel: this.variables.additionalComment
    }

    let dialogRef = this.dialog.open(AcceptCommentEstimateDialog, {
      data: data
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.estimativaService.certifyEstimate(this.estimate.id, result.commentary).subscribe({
          next: (data) => {
            if (data.success) {
              this.infoBar.showSnackbar(this.variables.successfullyCertifiedEstimate, ['successful-snackbar'], 3500);

              this.refreshUnreadNotifications(true);
              this.getEstimateById();
            }
          },
          error: (error) => {
            console.error('Error:', error.error);
            console.error('Full error object:', error);
            console.error('Error message from backend:', error.error?.message);

            const message = this.errorMessages[error.error.message] || error.error.message || this.variables.unknownError;
            this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
          }
        })
      }
      else {
        console.error("Error adding review estimate: ", result.error.message);

        const message = this.errorMessages[result.error.message]
        this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);

        console.error("Error adding review estimate: ", result.message);
      }
    })
  }

  closeEstimate() {
    this.estimativaService.getImputation(this.estimate.id).subscribe({
      next: (imputation: any) => {
        console.log(imputation);

        let allFilled: any;

        if (imputation != null) {
          allFilled = imputation.imputations.every((i: any) => i.actualHours > 0);
        }

        if (!allFilled || imputation == null) {
          this.infoBar.showSnackbar(
            this.variables.closeRequiresImputation,
            ['error-snackbar'], 5000
          );
          return;
        }

        const proceedWithClose = () => {
          const data = {
            title: this.variables.sureToCloseEstimate,
            accept: true,
            isRequired: false,
            commentaryLabel: this.variables.additionalComment
          }

          let dialogRef = this.dialog.open(AcceptCommentEstimateDialog, {
            data: data
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.estimativaService.closeEstimate(this.estimate.id, result.commentary).subscribe({
                next: (data) => {
                  if (data.success) {
                    this.infoBar.showSnackbar(this.variables.successfullyClosedEstimate, ['successful-snackbar'], 3500);

                    this.refreshUnreadNotifications(true);
                    this.getEstimateById();
                  }
                },
                error: (error) => {
                  console.error('Error:', error.error);
                  console.error('Full error object:', error);
                  console.error('Error message from backend:', error.error?.message);

                  const message = this.errorMessages[error.error.message] || error.error.message || this.variables.unknownError;
                  this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
                }
              })
            }
            else {
              console.error("Error adding review estimate: ", result.error.message);

              const message = this.errorMessages[result.error.message]
              this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);

              console.error("Error adding review estimate: ", result.message);
            }
          })
        };

        if (this.project?.initialCost == null) {
          const confirmRef = this.dialog.open(ConfirmInitialCostDialogComponent, {
            data: { amount: this.finalCostEuros }
          });
          confirmRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
              proceedWithClose();
            }
          });
        } else {
          proceedWithClose();
        }
      },
      error: () => {
        this.infoBar.showSnackbar(
          this.variables.closeRequiresImputation || 'You must complete all the real hours in tab Real Imputation before changing the state to closed',
          ['error-snackbar'], 5000
        );
      }
    });
  }

  addComment() {
    const data = {
      title: this.variables.addComment,
      accept: false,
      isRequired: true,
      commentaryLabel: this.variables.comment
    }

    let dialogRef = this.dialog.open(AcceptCommentEstimateDialog, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.estimativaService.addReview(this.estimate.id, result.commentary).subscribe({
          next: (data) => {

            if (data.success) {
              this.infoBar.showSnackbar(this.variables.reviewAddedSuccessfully, ['successful-snackbar'], 3500);
              this.refreshUnreadNotifications(true);

              this.getEstimateById();
              //if (this.authService.isUser())
              //  this.router.navigate(['/dashboard']);

            }
          },
          error: (error) => {
            console.error('Error:', error.error);

            const message = this.errorMessages[error.error.message]
            this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
          }
        })
      }
      else {
        console.error("Error adding review estimate: ", result.error.message);

        const message = this.errorMessages[result.error.message]
        this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);

        console.error("Error adding review estimate: ", result.message);
      }
    })

  }

  openDialogSaveState(value: string) {

  }

  getStateText(level: any): string {
    switch (level) {
      case this.estimationState.COMPLETE:
        return this.variables.finished;
      case this.estimationState.INCOMPLETE:
        return this.variables.onGoing;
      case this.estimationState.CERTIFIED:
        return this.variables.certified;
      case this.estimationState.APPROVED:
        return this.variables.approved;
      case this.estimationState.REJECTED:
        return this.variables.rejected;
      case this.estimationState.TO_FIX:
        return this.variables.toFix;
      case this.estimationState.CLOSED:
        return this.variables.Closed;
      default:
        return '';
    }
  }

  getStateActionText(state: any): string {
    switch (state) {
      case this.estimationState.CERTIFIED:
        return this.variables.hasCertifiedEstimate;
      case this.estimationState.APPROVED:
        return this.variables.hasApprovedEstimate;
      case this.estimationState.REJECTED:
        return this.variables.hasRejectedEstimate;
      case this.estimationState.TO_FIX:
        return this.variables.hasSentToFixEstimate;
      case this.estimationState.CLOSED:
        return this.variables.hasClosedEstimate;
      case this.estimationState.COMPLETE:
        return this.variables.hasCompletedEstimate;
      default:
        return state;
    }
  }


  cancelServices() {
    if (this.startingEstimate) {
      this.estimate = JSON.parse(JSON.stringify(this.startingEstimate));
      this.calculateEstimate(this.estimate.id);
    }

    this.showSliderDisclaimer = false;
    this.editMode = false;
    this.closeAllDetailTables();
  }

  formatLabel(value: number): string {

    const costPerHour = "" + this.originalProfileSnapShots[value].profileName + " " + this.originalProfileSnapShots[value].costPerHour.toString()

    return `${costPerHour}`;
  }

  resetServices(): void {
    if (!this.isOwner || !this.editMode || !this.startingEstimate) {
      return;
    }

    this.estimate = JSON.parse(JSON.stringify(this.startingEstimate));
    this.calculateEstimate(this.estimate.id);
    //this.closeAllDetailTables();
    this.sliderValue = 0;
    this.previousSliderValue = 0;
    this.showSliderDisclaimer = false;
  }

  toggleProfileEditMode(): void {
    if (!this.isOwner) return;

    if (!this.editMode) {
      this.startingEstimate = JSON.parse(JSON.stringify(this.estimate));
      this.sliderValue = 0;
      this.previousSliderValue = 0;
    }
    else {
      this.closeAllDetailTables();
    }
    this.editMode = !this.editMode;
  }

  private closeAllDetailTables(): void {
    this.div1Visible = false;
    this.div2Visible = false;
    this.div3Visible = false;
    this.div4Visible = false;
    this.div5Visible = false;
    this.div6Visible = false;
    this.div8Visible = false;
  }

  updateProfileAverage(value: number): void {
    if (!this.isOwner || !this.editMode || this.availableProfiles.length === 0) {
      return;
    }

    const nextSliderValue = Number(value ?? this.sliderValue ?? 0);
    const profileDelta = nextSliderValue - this.previousSliderValue;

    if (!Number.isFinite(profileDelta) || profileDelta === 0) {
      this.previousSliderValue = nextSliderValue;
      return;
    }

    const shiftProfileId = (profileId: string | null | undefined): string | null => {
      if (!profileId) {
        const fallbackIndex = profileDelta > 0 ? 0 : this.originalProfileSnapShots.length - 1;
        return this.originalProfileSnapShots[Math.max(0, Math.min(fallbackIndex, this.originalProfileSnapShots.length - 1))]?.profileId || null;
      }

      const currentIndex = this.originalProfileSnapShots.findIndex((profile) => profile.profileId === profileId);
      if (currentIndex === -1) {
        const fallbackIndex = profileDelta > 0 ? 0 : this.originalProfileSnapShots.length - 1;
        return this.originalProfileSnapShots[Math.max(0, Math.min(fallbackIndex, this.originalProfileSnapShots.length - 1))]?.profileId || null;
      }

      const targetIndex = Math.max(0, Math.min(currentIndex + profileDelta, this.originalProfileSnapShots.length - 1));
      return this.originalProfileSnapShots[targetIndex]?.profileId || profileId;
    };

    (this.estimate?.configurations || []).forEach((configuration: any) => {
      configuration.profileId = shiftProfileId(configuration.profileId);
    });

    (this.estimate?.parameters || []).forEach((param: any) => {
      param.profileId = shiftProfileId(param.profileId);
    });

    (this.estimate?.subTasks || []).forEach((subTask: any, idx: number) => {

      const prevSubTaskProfileId = subTask.profileId;
      subTask.profileId = shiftProfileId(subTask.profileId);


        if (subTask.tool ) {
          let stop = false
          this.summaryDTO?.productivityEarnings?.rows.forEach((row: any) => {
            if (!stop && row && row.subTaskIndex == idx
                && row.task === subTask.task 
                && row.subTask === subTask.subTask 
                && row.profileId === prevSubTaskProfileId 
                && row.toolName === subTask.tool.name 
                && row.productivity === subTask.tool.productivity) {

              const prevCostSavings = this.getCostPerHourForProfile(row.profileId) * row.gains;
              this.summaryDTO.productivityEarnings.totalCost -= prevCostSavings;
              this.summaryDTO.result.totalCostNoRisk += prevCostSavings;

              row.profileId = subTask.profileId;
              
              row.costSavings = this.getCostPerHourForProfile(row.profileId) * row.gains;
              this.summaryDTO.productivityEarnings.totalCost += row.costSavings;
              
              this.summaryDTO.result.totalCostNoRisk -= row.costSavings;

              stop = true;
            }        
          });
        }


    });

    (this.estimate?.macroActivities || []).forEach((macro: any) => {
      (macro?.macroActivities || []).forEach((macroActivity: any) => {
        macroActivity.profileId = shiftProfileId(macroActivity.profileId);
      });
    });

    //update DTOs
    (this.summaryDTO?.configurations.rows || []).forEach((row: any) => {
        const prevCost = this.getCostPerHourForProfile(row.profileId) * row.complexity
        row.totalCost -= prevCost;
        this.summaryDTO.result.totalCostNoRisk -= prevCost;

        row.profileId = shiftProfileId(row.profileId);

        row.cost = this.getCostPerHourForProfile(row.profileId) * row.complexity;
        row.totalCost += row.cost;

        this.summaryDTO.result.totalCostNoRisk += row.cost;
    });

    (this.summaryDTO?.parameters.rows || []).forEach((row: any) => {
        const prevCost = this.getCostPerHourForProfile(row.profileId) * row.complexity
        row.totalCost -= prevCost;
        this.summaryDTO.result.totalCostNoRisk -= prevCost;

        row.profileId = shiftProfileId(row.profileId);

        row.cost = this.getCostPerHourForProfile(row.profileId) * row.complexity;
        row.totalCost += row.cost;

        this.summaryDTO.result.totalCostNoRisk += row.cost;
    });

    (this.summaryDTO?.projectActivities.rows || []).forEach((row: any) => {
        const prevCost = this.getCostPerHourForProfile(row.profileId) * row.complexity
        row.totalCost -= prevCost;
        this.summaryDTO.result.totalCostNoRisk -= prevCost;

        row.profileId = shiftProfileId(row.profileId);

        row.cost = this.getCostPerHourForProfile(row.profileId) * row.complexity;
        row.totalCost += row.cost;

        this.summaryDTO.result.totalCostNoRisk += row.cost;
    });
    
    (this.summaryDTO?.macroActivities.rows || []).forEach((row: any) => {
        const prevCost = this.getCostPerHourForProfile(row.profileId) * row.complexity
        row.totalCost -= prevCost;
        this.summaryDTO.result.totalCostNoRisk -= prevCost;

        row.profileId = shiftProfileId(row.profileId);
        
        row.cost = this.getCostPerHourForProfile(row.profileId) * row.complexity;
        row.totalCost += row.cost;

        this.summaryDTO.result.totalCostNoRisk += row.cost;
    });

    this.showSliderDisclaimer = true;
    this.previousSliderValue = nextSliderValue;

    //this.rebuildProfileSnapshotsFromEstimate();
    this.recalculateTotalValuesAfterProfileEdit();
  }

  onProfileSelectionChange(element: any, profileId: string | null): void {
    if (!this.isOwner) return;
    if (!element?.sourceGroup) return;

    console.log("element:"+element);
    console.log("profileId:"+profileId);

    if (element.sourceGroup === 'macroActivities') {
      const estimateMacro = this.estimate?.macroActivities?.[element.sourceMacroIndex];
      const macroItem = estimateMacro?.macroActivities?.find((ma: any) => ma.name === element.sourceName);
      if (macroItem) {
        macroItem.profileId = profileId;
      }

      const macroSummaryRow = this.summaryDTO?.macroActivities?.rows?.[element.sourceMacroIndex];
      if (macroSummaryRow) {
        const prevCost = this.getCostPerHourForProfile(macroSummaryRow.profileId) * macroSummaryRow.complexity
        
        this.summaryDTO.macroActivities.totalCost -= prevCost;
        this.summaryDTO.result.totalCostNoRisk -= prevCost;

        macroSummaryRow.profileId = profileId;
        
        macroSummaryRow.cost = this.getCostPerHourForProfile(profileId) * macroSummaryRow.complexity;
        this.summaryDTO.macroActivities.totalCost += macroSummaryRow.cost;

        this.summaryDTO.result.totalCostNoRisk += macroSummaryRow.cost;
      }
    } 
    else if (element.sourceGroup === 'subTasks') {
      const estimateSubTask = this.estimate?.subTasks?.[element.sourceIndex];
      console.log('Updating profile for subTask:', element.sourceName, 'Current subTask:', estimateSubTask);
      let prevSubTaskProfileId = ""
      if (estimateSubTask) {
        prevSubTaskProfileId = estimateSubTask.profileId
        estimateSubTask.profileId = profileId;


        if (estimateSubTask.tool ) {
          let stop = false
          this.summaryDTO?.productivityEarnings?.rows.forEach((row: any) => {
            if (!stop && row && row.subTaskIndex == element.sourceIndex
                && row.task === estimateSubTask.task 
                && row.subTask === estimateSubTask.subTask 
                && row.profileId === prevSubTaskProfileId 
                && row.toolName === estimateSubTask.tool.name 
                && row.productivity === estimateSubTask.tool.productivity) {

              const prevCostSavings = this.getCostPerHourForProfile(row.profileId) * row.gains;
              this.summaryDTO.productivityEarnings.totalCost -= prevCostSavings;
              this.summaryDTO.result.totalCostNoRisk += prevCostSavings;

              row.profileId = profileId;
              
              row.costSavings = this.getCostPerHourForProfile(profileId) * row.gains;
              this.summaryDTO.productivityEarnings.totalCost += row.costSavings;
              
              this.summaryDTO.result.totalCostNoRisk -= row.costSavings;

              stop = true;
            }        
          });
        }
      }

      const subTaskSummaryRow = this.summaryDTO?.projectActivities?.rows?.[element.sourceIndex];
      if (subTaskSummaryRow) {
        const prevCost = this.getCostPerHourForProfile(subTaskSummaryRow.profileId) * subTaskSummaryRow.complexity
        this.summaryDTO.projectActivities.totalCost -= prevCost;

        this.summaryDTO.result.totalCostNoRisk -= prevCost;
        subTaskSummaryRow.profileId = profileId;
        
        subTaskSummaryRow.cost = this.getCostPerHourForProfile(profileId) * subTaskSummaryRow.complexity;
        this.summaryDTO.projectActivities.totalCost += subTaskSummaryRow.cost;
        
        this.summaryDTO.result.totalCostNoRisk += subTaskSummaryRow.cost;
      }

    }
    else {
      const group = this.estimate?.[element.sourceGroup];
      if (Array.isArray(group) && element.sourceIndex < group.length) {
        group[element.sourceIndex].profileId = profileId;

        const summaryRow = this.summaryDTO?.[element.sourceGroup]?.rows?.[element.sourceIndex];
        if (summaryRow) {
          const prevCost = this.getCostPerHourForProfile(summaryRow.profileId) * summaryRow.complexity
          this.summaryDTO[element.sourceGroup].totalCost -= prevCost;
          this.summaryDTO.result.totalCostNoRisk -= prevCost;
          summaryRow.profileId = profileId;
          if (element.sourceGroup == "configurations" || element.sourceGroup == "parameters") {
            
            summaryRow.cost = this.getCostPerHourForProfile(profileId) * summaryRow.complexity;
            
            this.summaryDTO[element.sourceGroup].totalCost += summaryRow.cost;

            this.summaryDTO.result.totalCostNoRisk += summaryRow.cost;
          }
        }
      }
    }

    this.upsertProfileSnapshot(profileId);

    this.rebuildProfileSnapshotsFromEstimate();

    this.originalProfileSnapShots = JSON.parse(JSON.stringify(this.estimate.profileSnapshots));

    this.recalculateTotalValuesAfterProfileEdit();
  }

  onProfileSelectOpenedChange(opened: boolean): void {
    if (opened) {
      this.profileSearchTerm = '';
    }
  }

  getFilteredAvailableProfiles(): Profile[] {
    const search = (this.profileSearchTerm || '').trim().toLowerCase();
    if (!search) {
      return this.availableProfiles;
    }

    return this.availableProfiles.filter((profile: Profile) => {
      const text = `${profile.center || ''} ${profile.name || ''} ${profile.costPerHour ?? ''}`.toLowerCase();
      return text.includes(search);
    });
  }

    getLowestCostProfile(): any  {

            //lowest value in sorted table
      return (this.estimate.profileSnapshots.length > this.sliderValue ) ? 
                this.estimate.profileSnapshots[(this.sliderValue<=this.estimate.profileSnapshots.length-1?this.sliderValue:
                this.estimate.profileSnapshots.length-1)]:null

    if (!Array.isArray(this.estimate.profileSnapshots)) return null;
    return this.estimate.profileSnapshots.reduce((lowest: any, current: any) => {
      if (!lowest || (current.costPerHour < lowest.costPerHour)) {
        return current;
      }
      return lowest;
    }, null);
  }

  private upsertProfileSnapshot(profileId: string | null): void {
    if (!profileId) return;

    if (!Array.isArray(this.estimate.profileSnapshots)) {
      this.estimate.profileSnapshots = [];
    }

    if (this.estimate.profileSnapshots.some((ps: any) => ps.profileId === profileId)) {
      return;
    }

    const profile = this.availableProfiles.find((p: Profile) => p.id === profileId);
    if (!profile) return;

    this.estimate.profileSnapshots.push({
      profileId: profile.id,
      profileName: profile.name,
      profileCenter: profile.center,
      costPerHour: profile.costPerHour || 0,
    });
  }

  private refreshCostsFromCurrentEstimateResult(): void {
    if (!this.summaryDTO) return;

    this.checkHasCosts();
    this.resetResultTables();
   
    //update risk DTO and resultDTO for the profileId with the lowest cost
    const lowestCostProfile = this.getLowestCostProfile();

    let oldTotalRiskCost = 0;
    let newTotalRiskCost = 0;
    this.summaryDTO?.risk.rows.forEach((row: any) => {

      const oldCost = row.cost;
      const newCost = lowestCostProfile.costPerHour * (row.risk/100.) * this.totalSumNoRisk
      row.profile = lowestCostProfile.costPerHour
      row.profileName = lowestCostProfile.profileName 
      row.profileId = lowestCostProfile.profileId
      row.cost = newCost

      newTotalRiskCost += newCost;
      oldTotalRiskCost += oldCost;
    });
    this.summaryDTO.risk.totalCost = newTotalRiskCost;


    //update final Costs in summaryDTO result based on the new risk profile costs
    this.summaryDTO.result.finalTotalCost = this.summaryDTO.result.totalCostNoRisk + newTotalRiskCost;

    this.setAllTotal(this.summaryDTO);
    this.setTable(this.summaryDTO, 'all');
  }

  private recalculateTotalValuesAfterProfileEdit(): void {
    this.refreshCostsFromCurrentEstimateResult();
    this.cdr.detectChanges();
  }

  private rebuildProfileSnapshotsFromEstimate(): void {
    const allProfileIds = new Set<string>();

    (this.estimate?.configurations || []).forEach((c: any) => { if (c.profileId) allProfileIds.add(c.profileId); });
    (this.estimate?.parameters || []).forEach((p: any) => { if (p.profileId) allProfileIds.add(p.profileId); });
    (this.estimate?.macroActivities || []).forEach((macro: any) => {
      (macro?.macroActivities || []).forEach((ma: any) => { if (ma.profileId) allProfileIds.add(ma.profileId); });
    });
    (this.estimate?.subTasks || []).forEach((st: any) => { if (st.profileId) allProfileIds.add(st.profileId); });

    (this.summaryDTO?.configurations?.rows || []).forEach((c: any) => { if (c.profileId) allProfileIds.add(c.profileId); });
    (this.summaryDTO?.parameters?.rows || []).forEach((p: any) => { if (p.profileId) allProfileIds.add(p.profileId); });
    (this.summaryDTO?.macroActivities?.rows || []).forEach((m: any) => { if (m.profileId) allProfileIds.add(m.profileId); });
    (this.summaryDTO?.projectActivities?.rows || []).forEach((st: any) => { if (st.profileId) allProfileIds.add(st.profileId); });
  
    //only add distinct profile to profileSnapshots
    this.estimate.profileSnapshots = Array.from(allProfileIds)
      .map(pid => {
        const profile = this.availableProfiles.find(p => p.id === pid);
        return profile ? { profileId: profile.id, profileName: profile.name, profileCenter: profile.center, costPerHour: profile.costPerHour || 0 } : null;
      })
        .filter((s: any) => s !== null)
        .sort((a: any, b: any) => a.costPerHour - b.costPerHour);
  
    
    this.sliderValues = [];
    for (let i = 0; i < this.estimate.profileSnapshots.length; i++) {
      this.sliderValues.push({
        value: i,
        type: ''
      });
    }
    this.maxSliderValue = this.estimate.profileSnapshots.length-1;

  }

  private resetResultTables(): void {
    this.projectRiskDataSource.data = [];
    this.configurationDataSource.data = [];
    this.parametersDataSource.data = [];
    this.macroDataSource.data = [];
    this.tasksDataSource.data = [];
    this.toolsDataSource.data = [];
    this.totalDataSource.data = [];
    this.filteredCatalogDataSourceMode1 = [];
    this.filteredCatalogDataSourceMode2 = [];
  }


  setTable(summaryDTO: any, typeTable: string) {

        // Conditionally call methods based on the specified typeTable value
    switch (typeTable) {

      case 'all':
        this.riskTable(summaryDTO);
        this.configTable(summaryDTO);
        this.paramsTable(summaryDTO);
        this.macrosTable(summaryDTO);
        this.tasksTable(summaryDTO);
        this.prodTable(summaryDTO);

        break;
      default:
        break;
    }

    let itemCount = 0;
    if (this.estimate.configurations && this.estimate.configurations.length > 0)
      itemCount++;
    if (this.estimate.parameters && this.estimate.parameters.length > 0)
      itemCount++;
    if (this.estimate.macroActivities && this.estimate.macroActivities.length > 0)
      itemCount++;
    if (this.estimate.subTasks && this.estimate.subTasks.length > 0)
      itemCount++;

    this.averageProfile = (this.averageProfileMacro + this.averageProfileSubTasks + this.averageProfileConfig + this.averageProfileParams)/itemCount;
    this.averageProfileNoRisk =  (this.totalCostTotalNoRisk/this.totalSumNoRisk);

    // Build data source dynamically based on what values are present
    const dataSourceItems: any[] = [];

    if (this.totalConfigurations > 0) {
      if (this.hasCosts)
        dataSourceItems.push({ name: this.variables.configurations, effort: Number(this.totalConfigurations).toFixed(2), profile: Number(this.averageProfileConfig).toFixed(2), cost: Number(this.totalCostConfig).toFixed(2), id: 2 });
      else
        dataSourceItems.push({ name: this.variables.configurations, effort: Number(this.totalConfigurations).toFixed(2), id: 2 });
    }

    if (this.totalParameters > 0) {
      if (this.hasCosts)
        dataSourceItems.push({ name: this.variables.parameters, effort: Number(this.totalParameters).toFixed(2), profile: Number(this.averageProfileParams).toFixed(2), cost: Number(this.totalCostParams).toFixed(2), id: 3 });
      else
        dataSourceItems.push({ name: this.variables.parameters, effort: Number(this.totalParameters).toFixed(2), id: 3 });
    }

    if (this.hasCosts)
      dataSourceItems.push({ name: this.variables.macroActivities, effort: Number(this.totalMacro).toFixed(2), profile: Number(this.averageProfileMacro).toFixed(2), cost: Number(this.totalCostMacros).toFixed(2), id: 4 });
    else
      dataSourceItems.push({ name: this.variables.macroActivities, effort: Number(this.totalMacro).toFixed(2),  id: 4 });      
    
    if (this.hasCosts)
      dataSourceItems.push({ name: this.variables.projectTasks, effort: Number(this.totalSubTasks).toFixed(2), profile: Number(this.averageProfileSubTasks).toFixed(2), cost: Number(this.totalCostActivities).toFixed(2), id: 5 });
    else
      dataSourceItems.push({ name: this.variables.projectTasks, effort: Number(this.totalSubTasks).toFixed(2), id: 5 });

    if (this.totalTools > 0) {
      if (this.hasCosts)
        dataSourceItems.push({ name: this.variables.prodTools, effort: Number(this.totalTools).toFixed(2), profile: Number(this.averageProfileTools).toFixed(2), cost: Number(this.totalCostProdTools).toFixed(2), id: 6 });
      else
        dataSourceItems.push({ name: this.variables.prodTools, effort: Number(this.totalTools).toFixed(2), id: 6 }); 
    }

    if (this.hasCosts)
      dataSourceItems.push({ name: this.variables.totalNoRisk,  effort: Number(this.totalSumNoRisk).toFixed(2), profile: Number(this.averageProfileNoRisk).toFixed(2), cost: Number(this.totalCostTotalNoRisk).toFixed(2), id: 7 });
    else
      dataSourceItems.push({ name: this.variables.totalNoRisk, effort: Number(this.totalSumNoRisk).toFixed(2), id: 7 });

    //lowest value in sorted table
    const profileCost = (this.estimate.profileSnapshots.length > this.sliderValue ) ? this.estimate.profileSnapshots[(this.sliderValue<=this.estimate.profileSnapshots.length-1?this.sliderValue:this.estimate.profileSnapshots.length-1)].costPerHour:0

    if (this.hasCosts)
      dataSourceItems.push({ name: this.variables.riskOfProject, effort: Number(this.totalProjectRisk).toFixed(2), profile: Number(profileCost).toFixed(2), cost: Number(this.totalCostRisk).toFixed(2), id: 8 }); 
    else
      dataSourceItems.push({ name: this.variables.riskOfProject, effort: Number(this.totalProjectRisk).toFixed(2), id: 8 });

    const finalCostEuros = this.totalCostTotal;
    const finalEffortHours = this.totalSum;
    if (this.hasCosts)
      dataSourceItems.push({ name: this.variables.total, effort: Number(finalEffortHours).toFixed(2), 
                            profile: finalEffortHours > 0 ? Number((finalCostEuros / finalEffortHours).toFixed(2)) : 0, 
                            cost: Number(finalCostEuros).toFixed(2), id: 9 });
    else
      dataSourceItems.push({ name: this.variables.total, effort: Number(finalEffortHours).toFixed(2), id: 9 });

    this.totalDataSource.data = dataSourceItems;

  }

  riskTable(summaryDTO: any) {

    summaryDTO?.risk.rows.forEach((row: any) => {

      this.projectRiskDataSource.data.push({
        name: row.name,
        risk: row.risk,
        effort: (row.risk/100.) * this.totalSumNoRisk, //without risk of course
        profile: this.getCostPerHourForProfile(row.profileId),
        profileName: this.getProfileName(row.profileId),
        profileId: row.profileId,
        cost: row.cost
      });
    });

  }
  
  prodTable(summaryDTO: any) {

    summaryDTO.productivityEarnings.rows.forEach((row: any) => {

      this.toolsDataSource.data.push({
        actionName: row.task,
        activityName: row.subTask,
        toolName: row.toolName,
        gains: row.gains,
        productivity:row.productivity,
        profileName: this.getProfileName(row.profileId),
        profile: this.getCostPerHourForProfile(row.profileId),
        profileId: row.profileId,
        cost: row.costSavings
      })
    });
  }

  tasksTable(summaryDTO: any) {

    // Set data for mat table (Activities table)
    summaryDTO.projectActivities.rows.forEach((row: any, i: number) => {
  
      this.tasksDataSource.data.push({
        epic: row.epic,
        userStory: row.userStory,
        task: row.task,
        subTask: row.subTask,
        complexityLevel: row.complexityLevel,
        tshirtScaleLevel: row.tshirtScaleLevel,
        complexityCount: row.itemCount + ' x ' + (row.complexity / row.itemCount).toFixed(2) + ' = ' + row.complexity.toFixed(2),
        profileName: this.getProfileName(row.profileId),
        profile: this.getCostPerHourForProfile(row.profileId),
        cost: row.cost,
        profileId : row.profileId,
        sourceGroup: 'subTasks',
        sourceIndex: i,
      });
    })

    this.filterDataSource();
  }
  
  macrosTable(summaryDTO: any) {

    summaryDTO.macroActivities.rows.forEach((row: any, i: number) => {

      this.macroDataSource.data.push({
          name: row.name,
          type: row.type,
          effort: row.effort,
          complexity: row.complexity,
          profileName: this.getProfileName(row.profileId),
          profile: this.getCostPerHourForProfile(row.profileId),
          cost: row.cost,
          profileId: row.profileId,
          sourceGroup: 'macroActivities',
          sourceMacroIndex: i,
          sourceName: row.name,
        })
    });
  }

  paramsTable(summaryDTO: any) {

    summaryDTO.parameters.rows.forEach((row: any, i: number) => {
      this.parametersDataSource.data.push({
        name: row.name,
        complexity: row.complexity,
        profileName: this.getProfileName(row.profileId),
        profile: this.getCostPerHourForProfile(row.profileId),
        cost: row.cost,
        profileId: row.profileId,
        sourceGroup: 'parameters',
        sourceIndex: i,
      })
    })
  }

  configTable(summaryDTO: any) {
   
    summaryDTO.configurations.rows.forEach((row: any, i: number) => {

      this.configurationDataSource.data.push({
        name: row.name,
        complexity: row.complexity,
        profileName: this.getProfileName(row.profileId),
        profile: this.getCostPerHourForProfile(row.profileId),
        cost: row.cost,
        profileId: row.profileId,
        sourceGroup: 'configurations',
        sourceIndex: i,
      })
    })
  }


  saveChanges() {
    if (!this.isOwner) return;

    this.estimativaService.updateEstimate(this.estimate.id, this.estimate).subscribe({
      next: (updatedEstimate: any) => {
        this.startingEstimate = this.estimate;;
        this.infoBar.showSnackbar(this.variables.successfullyEditedEstimate, ['successful-snackbar'], 3500);
        this.showSliderDisclaimer = false;
        this.editMode = false;
        this.closeAllDetailTables();
        this.calculateEstimate(this.estimate.id);
        this.getEstimateById();
      },
      error: (error) => {
        const message = this.errorMessages[error?.error?.message] || this.variables.detectedError;
        this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
      }
    });
  }

  saveChangesServices() {
  }

  realSaveEstimate() {
    let configurations = this.configurationDataSource.data.map((item: any) => ({ ...item }));
    let parameters = this.parametersDataSource.data.map((item: any) => ({ ...item }));
    let macroActivities = this.macroDataSource.data.map((item: any) => ({ ...item }));
    let actionItems = this.tasksDataSource.data.map((item: any) => ({ ...item })); // Create copies of the objects
    let projectType = Object.assign({}, this.projectRiskDataSource.data[0]);

    //Add values missing from datasource to the object
    actionItems.forEach((item: any, index: number) => {  // Use 'any' type for flexibility
      item.tool = this.estimate.actionItems[index].tool;
      item.itemCount = this.estimate.actionItems[index].itemCount;
      delete item.scr;
      delete item.complexityCount;
    });

    delete projectType.scr;

    macroActivities.forEach((item: any, index: number) => {  // Use 'any' type for flexibility
      delete item.scr;
      delete item.effort;
    });

    parameters.forEach((item: any, index: number) => {  // Use 'any' type for flexibility
      delete item.scr;
    });

    configurations.forEach((item: any, index: number) => {  // Use 'any' type for flexibility
      delete item.scr;
    });

    this.estimate.totalTime = this.totalSum;
    this.estimate.gainTime = this.totalTools;
    this.estimate.configurations = configurations;
    this.estimate.parameters = parameters;
    this.estimate.macroActivities = macroActivities;
    this.estimate.actionItems = actionItems;
    this.estimate.projectType = projectType;

    this.estimativaService.updateEstimateTimes(this.estimate).subscribe((data2: any) => {

      const i = this.project.estimates.findIndex((est: any) => est == this.project.estimates.find((estimate: any) => { return estimate.id == this.estimate.id }))

      if (i == -1) {
        this.project.estimates.push(this.estimate);
      }
      else {
        this.project.estimates[i] = this.estimate;
      }

      this.projectService.updateProject(this.project);

    });
  }


  updateEstimateTimes() {
    this.estimate.totalEffortHours = this.totalSum;
    this.estimate.totalGainTime = this.totalTools;

    this.estimativaService.updateEstimateTimes(this.estimate).subscribe({
      next: (data) => { },
      error: (error) => {
        const message = this.errorMessages[error.error.message];
        this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
      }
    });

  }

  filterDataSource() {
    const dataArray = this.tasksDataSource.data;
    this.filteredCatalogDataSourceMode1 = dataArray.filter((item: any) => item.complexityLevel !== null);
    this.filteredCatalogDataSourceMode2 = dataArray.filter((item: any) => item.tshirtScaleLevel !== null);

  }

  sumSaleCost() {
    let total = 0;
    this.summaryDTO.answers.forEach((answer: any) => {
      total += answer.saleCost;
    })
    return total;
  }

  getProjectById(id: string) {

    this.projectService.getProjectById(id).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error; // Exceeded retry attempts, propagate error
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        const message = this.errorMessages[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any[]) => {
        try {
          this.project = data;
          this.updateAddCommentVisibility();
        } catch (err) {
          console.error('Error processing data:', err);
          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
    });
  }

  isMember() {
    const isMember = this.project?.users?.some((member: any) => member.email === this.email);

    return !!isMember;
  }

  isOwnerOrMember() {
    const isMember = this.project?.users?.some((member: any) => member.email === this.email);

    return this.isOwner || !!isMember;
  }

  private updateAddCommentVisibility(): void {
    this.canShowAddCommentButton = this.isOwnerOrMember() || this.role == this.Roles.SUPER_ADMIN || this.role == this.Roles.ESTIMATION_OFFICE
    console.log('canShowAddCommentButton:', this.canShowAddCommentButton);
  }
}
